/**
 * Fusionne les lignes d'un formulaire d'adresse (ligne 1, ligne 2, ligne 3 facultatives)
 * en une seule chaîne, pour l'envoi au backend, l'affichage ou la géolocalisation sur la carte.
 * @param {...(string|undefined|null)} lines
 * @returns {string}
 */
export const mergeAddressLines = (...lines) =>
  lines
    .map((line) => (line || '').trim())
    .filter(Boolean)
    .join(', ');
